module.exports = __webpack_public_path__ + "67b2c8ac425d998fe3f7965eb06feb78.png";